import { trackEventFromState } from '@eventbrite/site-analytics';
import {
    GA_EVENTBRITE,
    GA_PASSWORDLESS_EMAIL_ATTEMPT,
    GA_PASSWORDLESS_EMAIL_FAILED,
    GA_PASSWORDLESS_EMAIL_MODAL_CLOSE,
    GA_PASSWORDLESS_EMAIL_MODAL_OPEN,
    GA_PASSWORDLESS_EMAIL_SENT,
    GA_PASSWORDLESS_LOGIN_FAILED,
    GA_PASSWORDLESS_SUCCESS,
} from '../constants/analytics';
import {
    trackGeneralAuthAction,
    trackGeneralPageUnloadAuthAction,
} from './general';
import { IAnalyticsDimensionsProps } from './interfaces';
import { capitalize, getAnalyticsCategory } from './utils';

export const trackPasswordlessEmailAttempt = ({
    socialProvider,
    analytics,
}: {
    socialProvider: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_PASSWORDLESS_EMAIL_ATTEMPT,
        label: capitalize(socialProvider),
        analytics,
    });
};

export const trackPasswordlessEmailFailed = ({
    errorMessage,
    analytics,
}: {
    errorMessage: any;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralAuthAction({
        action: GA_PASSWORDLESS_EMAIL_FAILED,
        label: errorMessage,
        analytics,
    });
};

export const trackPasswordlessEmailSent = ({
    socialProvider,
    analytics,
}: {
    socialProvider: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackGeneralPageUnloadAuthAction({
        action: GA_PASSWORDLESS_EMAIL_SENT,
        label: capitalize(socialProvider),
        analytics,
    });
};

export const trackPasswordlessSuccess = ({
    isHardAccount,
    analytics,
}: {
    isHardAccount?: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    const extraLabel = isHardAccount == 'True' ? 'HardAccount' : 'SoftAccount';

    trackGeneralAuthAction({
        action: GA_PASSWORDLESS_SUCCESS,
        label: extraLabel,
        analytics,
    });
};

export const trackPasswordlessLoginFailed = ({
    isHardAccount,
    errorMessage,
    analytics,
}: {
    isHardAccount?: string;
    errorMessage: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    const extraLabel = isHardAccount == 'True' ? 'HardAccount' : 'SoftAccount';

    trackGeneralAuthAction({
        action: GA_PASSWORDLESS_LOGIN_FAILED + extraLabel,
        label: errorMessage,
        analytics,
    });
};

export const trackOpenPasswordlessModal = ({
    error,
    analytics,
}: {
    error?: string;
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackEventFromState(analytics, {
        category: getAnalyticsCategory(analytics),
        action: GA_PASSWORDLESS_EMAIL_MODAL_OPEN,
        label: error ?? GA_EVENTBRITE,
    });
};

export const trackClosePasswordlessModal = ({
    analytics,
}: {
    analytics?: IAnalyticsDimensionsProps;
}) => {
    trackEventFromState(analytics, {
        category: getAnalyticsCategory(analytics),
        action: GA_PASSWORDLESS_EMAIL_MODAL_CLOSE,
    });
};
